import { Table } from "@radix-ui/themes";
import { useStore } from "./Store";
import { rrulestr } from "rrule";

const JamList: React.FC = () => {
  const { store, selectJam } = useStore();
  return (
    <Table.Root>
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeaderCell>Name</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Upcoming Date</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Start Time</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Venue</Table.ColumnHeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {
          store.loaded &&
          store.jams.map((jam, index) => {
              const recurrance = rrulestr(jam.time.rrule);
              const upcoming = recurrance.after(new Date());

              return <Table.Row
                key={index}
                onClick={() => selectJam(jam.id)}
                className="cursor-pointer transition-all hover:underline hover:transform-[translateY(-5px)]"
              >
                <Table.RowHeaderCell>{jam.name}</Table.RowHeaderCell>
                <Table.Cell>{upcoming?.toDateString()}</Table.Cell>
                <Table.Cell>{upcoming?.toLocaleTimeString().slice(0, -3)}</Table.Cell>
                <Table.Cell>{jam.venue.name}</Table.Cell>
              </Table.Row>;
            })
        }
      </Table.Body>
    </Table.Root>

  );
};

export default JamList;
